<template lang="pug">
  label.label(:for="id") {{ label }}
</template>
<script>
export default {
  name: 'Label',
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .label {
    color: #595959;
  }
</style>
